/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NoticeRouteImport } from './routes/notice'
import { Route as HomeRouteImport } from './routes/home'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as ReportIndexRouteImport } from './routes/report/index'
import { Route as ExportIndexRouteImport } from './routes/export/index'
import { Route as ActivityIndexRouteImport } from './routes/activity/index'
import { Route as SignupAuthCodeRouteImport } from './routes/signup/$authCode'
import { Route as SettingsOverviewRouteImport } from './routes/settings/overview'
import { Route as ReportTrendRouteImport } from './routes/report/trend'
import { Route as ReportReportRouteImport } from './routes/report/report'
import { Route as ReportDailyRouteImport } from './routes/report/daily'
import { Route as ReportAiReportRouteImport } from './routes/report/ai-report'
import { Route as ExportPdfRouteImport } from './routes/export/pdf'
import { Route as ExportCsvRouteImport } from './routes/export/csv'
import { Route as ActivityListRouteImport } from './routes/activity/list'
import { Route as ActivityDetailRouteImport } from './routes/activity/detail'
import { Route as SettingsResourcesIndexRouteImport } from './routes/settings/resources/index'
import { Route as SettingsReportIndexRouteImport } from './routes/settings/report/index'
import { Route as SettingsPreferencesIndexRouteImport } from './routes/settings/preferences/index'
import { Route as SettingsMetricIndexRouteImport } from './routes/settings/metric/index'
import { Route as SettingsClubIndexRouteImport } from './routes/settings/club/index'
import { Route as SettingsAnalysisGroupsIndexRouteImport } from './routes/settings/analysis-groups/index'
import { Route as SettingsResourcesDownloadRouteImport } from './routes/settings/resources/download'
import { Route as SettingsReportTrendRouteImport } from './routes/settings/report/trend'
import { Route as SettingsReportReportRouteImport } from './routes/settings/report/report'
import { Route as SettingsReportFilterPresetRouteImport } from './routes/settings/report/filter-preset'
import { Route as SettingsReportDailyRouteImport } from './routes/settings/report/daily'
import { Route as SettingsPreferencesUnitsRouteImport } from './routes/settings/preferences/units'
import { Route as SettingsPreferencesLanguagesRouteImport } from './routes/settings/preferences/languages'
import { Route as SettingsMetricZonesRouteImport } from './routes/settings/metric/zones'
import { Route as SettingsMetricCalculatorRouteImport } from './routes/settings/metric/calculator'
import { Route as SettingsMetricAdvancedRouteImport } from './routes/settings/metric/advanced'
import { Route as SettingsMetricActionsRouteImport } from './routes/settings/metric/actions'
import { Route as SettingsClubTransitionRouteImport } from './routes/settings/club/transition'
import { Route as SettingsClubPlayersRouteImport } from './routes/settings/club/players'
import { Route as SettingsClubCoachesRouteImport } from './routes/settings/club/coaches'
import { Route as SettingsAnalysisGroupsSessionsRouteImport } from './routes/settings/analysis-groups/sessions'
import { Route as SettingsAnalysisGroupsSeasonRouteImport } from './routes/settings/analysis-groups/season'
import { Route as SettingsAnalysisGroupsPlayersRouteImport } from './routes/settings/analysis-groups/players'
import { Route as SettingsClubEquipmentsIndexRouteImport } from './routes/settings/club/equipments/index'
import { Route as SettingsClubEquipmentsDeliveryRouteImport } from './routes/settings/club/equipments/delivery'

const NoticeRoute = NoticeRouteImport.update({
  id: '/notice',
  path: '/notice',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportIndexRoute = ReportIndexRouteImport.update({
  id: '/report/',
  path: '/report/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportIndexRoute = ExportIndexRouteImport.update({
  id: '/export/',
  path: '/export/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityIndexRoute = ActivityIndexRouteImport.update({
  id: '/activity/',
  path: '/activity/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupAuthCodeRoute = SignupAuthCodeRouteImport.update({
  id: '/signup/$authCode',
  path: '/signup/$authCode',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsOverviewRoute = SettingsOverviewRouteImport.update({
  id: '/settings/overview',
  path: '/settings/overview',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportTrendRoute = ReportTrendRouteImport.update({
  id: '/report/trend',
  path: '/report/trend',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportReportRoute = ReportReportRouteImport.update({
  id: '/report/report',
  path: '/report/report',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportDailyRoute = ReportDailyRouteImport.update({
  id: '/report/daily',
  path: '/report/daily',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportAiReportRoute = ReportAiReportRouteImport.update({
  id: '/report/ai-report',
  path: '/report/ai-report',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportPdfRoute = ExportPdfRouteImport.update({
  id: '/export/pdf',
  path: '/export/pdf',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportCsvRoute = ExportCsvRouteImport.update({
  id: '/export/csv',
  path: '/export/csv',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityListRoute = ActivityListRouteImport.update({
  id: '/activity/list',
  path: '/activity/list',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityDetailRoute = ActivityDetailRouteImport.update({
  id: '/activity/detail',
  path: '/activity/detail',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsResourcesIndexRoute = SettingsResourcesIndexRouteImport.update({
  id: '/settings/resources/',
  path: '/settings/resources/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsReportIndexRoute = SettingsReportIndexRouteImport.update({
  id: '/settings/report/',
  path: '/settings/report/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPreferencesIndexRoute =
  SettingsPreferencesIndexRouteImport.update({
    id: '/settings/preferences/',
    path: '/settings/preferences/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsMetricIndexRoute = SettingsMetricIndexRouteImport.update({
  id: '/settings/metric/',
  path: '/settings/metric/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsClubIndexRoute = SettingsClubIndexRouteImport.update({
  id: '/settings/club/',
  path: '/settings/club/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAnalysisGroupsIndexRoute =
  SettingsAnalysisGroupsIndexRouteImport.update({
    id: '/settings/analysis-groups/',
    path: '/settings/analysis-groups/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsResourcesDownloadRoute =
  SettingsResourcesDownloadRouteImport.update({
    id: '/settings/resources/download',
    path: '/settings/resources/download',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsReportTrendRoute = SettingsReportTrendRouteImport.update({
  id: '/settings/report/trend',
  path: '/settings/report/trend',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsReportReportRoute = SettingsReportReportRouteImport.update({
  id: '/settings/report/report',
  path: '/settings/report/report',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsReportFilterPresetRoute =
  SettingsReportFilterPresetRouteImport.update({
    id: '/settings/report/filter-preset',
    path: '/settings/report/filter-preset',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsReportDailyRoute = SettingsReportDailyRouteImport.update({
  id: '/settings/report/daily',
  path: '/settings/report/daily',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPreferencesUnitsRoute =
  SettingsPreferencesUnitsRouteImport.update({
    id: '/settings/preferences/units',
    path: '/settings/preferences/units',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsPreferencesLanguagesRoute =
  SettingsPreferencesLanguagesRouteImport.update({
    id: '/settings/preferences/languages',
    path: '/settings/preferences/languages',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsMetricZonesRoute = SettingsMetricZonesRouteImport.update({
  id: '/settings/metric/zones',
  path: '/settings/metric/zones',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMetricCalculatorRoute =
  SettingsMetricCalculatorRouteImport.update({
    id: '/settings/metric/calculator',
    path: '/settings/metric/calculator',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsMetricAdvancedRoute = SettingsMetricAdvancedRouteImport.update({
  id: '/settings/metric/advanced',
  path: '/settings/metric/advanced',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMetricActionsRoute = SettingsMetricActionsRouteImport.update({
  id: '/settings/metric/actions',
  path: '/settings/metric/actions',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsClubTransitionRoute = SettingsClubTransitionRouteImport.update({
  id: '/settings/club/transition',
  path: '/settings/club/transition',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsClubPlayersRoute = SettingsClubPlayersRouteImport.update({
  id: '/settings/club/players',
  path: '/settings/club/players',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsClubCoachesRoute = SettingsClubCoachesRouteImport.update({
  id: '/settings/club/coaches',
  path: '/settings/club/coaches',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAnalysisGroupsSessionsRoute =
  SettingsAnalysisGroupsSessionsRouteImport.update({
    id: '/settings/analysis-groups/sessions',
    path: '/settings/analysis-groups/sessions',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsAnalysisGroupsSeasonRoute =
  SettingsAnalysisGroupsSeasonRouteImport.update({
    id: '/settings/analysis-groups/season',
    path: '/settings/analysis-groups/season',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsAnalysisGroupsPlayersRoute =
  SettingsAnalysisGroupsPlayersRouteImport.update({
    id: '/settings/analysis-groups/players',
    path: '/settings/analysis-groups/players',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsClubEquipmentsIndexRoute =
  SettingsClubEquipmentsIndexRouteImport.update({
    id: '/settings/club/equipments/',
    path: '/settings/club/equipments/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsClubEquipmentsDeliveryRoute =
  SettingsClubEquipmentsDeliveryRouteImport.update({
    id: '/settings/club/equipments/delivery',
    path: '/settings/club/equipments/delivery',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/home': typeof HomeRoute
  '/notice': typeof NoticeRoute
  '/activity/detail': typeof ActivityDetailRoute
  '/activity/list': typeof ActivityListRoute
  '/export/csv': typeof ExportCsvRoute
  '/export/pdf': typeof ExportPdfRoute
  '/report/ai-report': typeof ReportAiReportRoute
  '/report/daily': typeof ReportDailyRoute
  '/report/report': typeof ReportReportRoute
  '/report/trend': typeof ReportTrendRoute
  '/settings/overview': typeof SettingsOverviewRoute
  '/signup/$authCode': typeof SignupAuthCodeRoute
  '/activity': typeof ActivityIndexRoute
  '/export': typeof ExportIndexRoute
  '/report': typeof ReportIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/settings/analysis-groups/players': typeof SettingsAnalysisGroupsPlayersRoute
  '/settings/analysis-groups/season': typeof SettingsAnalysisGroupsSeasonRoute
  '/settings/analysis-groups/sessions': typeof SettingsAnalysisGroupsSessionsRoute
  '/settings/club/coaches': typeof SettingsClubCoachesRoute
  '/settings/club/players': typeof SettingsClubPlayersRoute
  '/settings/club/transition': typeof SettingsClubTransitionRoute
  '/settings/metric/actions': typeof SettingsMetricActionsRoute
  '/settings/metric/advanced': typeof SettingsMetricAdvancedRoute
  '/settings/metric/calculator': typeof SettingsMetricCalculatorRoute
  '/settings/metric/zones': typeof SettingsMetricZonesRoute
  '/settings/preferences/languages': typeof SettingsPreferencesLanguagesRoute
  '/settings/preferences/units': typeof SettingsPreferencesUnitsRoute
  '/settings/report/daily': typeof SettingsReportDailyRoute
  '/settings/report/filter-preset': typeof SettingsReportFilterPresetRoute
  '/settings/report/report': typeof SettingsReportReportRoute
  '/settings/report/trend': typeof SettingsReportTrendRoute
  '/settings/resources/download': typeof SettingsResourcesDownloadRoute
  '/settings/analysis-groups': typeof SettingsAnalysisGroupsIndexRoute
  '/settings/club': typeof SettingsClubIndexRoute
  '/settings/metric': typeof SettingsMetricIndexRoute
  '/settings/preferences': typeof SettingsPreferencesIndexRoute
  '/settings/report': typeof SettingsReportIndexRoute
  '/settings/resources': typeof SettingsResourcesIndexRoute
  '/settings/club/equipments/delivery': typeof SettingsClubEquipmentsDeliveryRoute
  '/settings/club/equipments': typeof SettingsClubEquipmentsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/home': typeof HomeRoute
  '/notice': typeof NoticeRoute
  '/activity/detail': typeof ActivityDetailRoute
  '/activity/list': typeof ActivityListRoute
  '/export/csv': typeof ExportCsvRoute
  '/export/pdf': typeof ExportPdfRoute
  '/report/ai-report': typeof ReportAiReportRoute
  '/report/daily': typeof ReportDailyRoute
  '/report/report': typeof ReportReportRoute
  '/report/trend': typeof ReportTrendRoute
  '/settings/overview': typeof SettingsOverviewRoute
  '/signup/$authCode': typeof SignupAuthCodeRoute
  '/activity': typeof ActivityIndexRoute
  '/export': typeof ExportIndexRoute
  '/report': typeof ReportIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/settings/analysis-groups/players': typeof SettingsAnalysisGroupsPlayersRoute
  '/settings/analysis-groups/season': typeof SettingsAnalysisGroupsSeasonRoute
  '/settings/analysis-groups/sessions': typeof SettingsAnalysisGroupsSessionsRoute
  '/settings/club/coaches': typeof SettingsClubCoachesRoute
  '/settings/club/players': typeof SettingsClubPlayersRoute
  '/settings/club/transition': typeof SettingsClubTransitionRoute
  '/settings/metric/actions': typeof SettingsMetricActionsRoute
  '/settings/metric/advanced': typeof SettingsMetricAdvancedRoute
  '/settings/metric/calculator': typeof SettingsMetricCalculatorRoute
  '/settings/metric/zones': typeof SettingsMetricZonesRoute
  '/settings/preferences/languages': typeof SettingsPreferencesLanguagesRoute
  '/settings/preferences/units': typeof SettingsPreferencesUnitsRoute
  '/settings/report/daily': typeof SettingsReportDailyRoute
  '/settings/report/filter-preset': typeof SettingsReportFilterPresetRoute
  '/settings/report/report': typeof SettingsReportReportRoute
  '/settings/report/trend': typeof SettingsReportTrendRoute
  '/settings/resources/download': typeof SettingsResourcesDownloadRoute
  '/settings/analysis-groups': typeof SettingsAnalysisGroupsIndexRoute
  '/settings/club': typeof SettingsClubIndexRoute
  '/settings/metric': typeof SettingsMetricIndexRoute
  '/settings/preferences': typeof SettingsPreferencesIndexRoute
  '/settings/report': typeof SettingsReportIndexRoute
  '/settings/resources': typeof SettingsResourcesIndexRoute
  '/settings/club/equipments/delivery': typeof SettingsClubEquipmentsDeliveryRoute
  '/settings/club/equipments': typeof SettingsClubEquipmentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/home': typeof HomeRoute
  '/notice': typeof NoticeRoute
  '/activity/detail': typeof ActivityDetailRoute
  '/activity/list': typeof ActivityListRoute
  '/export/csv': typeof ExportCsvRoute
  '/export/pdf': typeof ExportPdfRoute
  '/report/ai-report': typeof ReportAiReportRoute
  '/report/daily': typeof ReportDailyRoute
  '/report/report': typeof ReportReportRoute
  '/report/trend': typeof ReportTrendRoute
  '/settings/overview': typeof SettingsOverviewRoute
  '/signup/$authCode': typeof SignupAuthCodeRoute
  '/activity/': typeof ActivityIndexRoute
  '/export/': typeof ExportIndexRoute
  '/report/': typeof ReportIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/settings/analysis-groups/players': typeof SettingsAnalysisGroupsPlayersRoute
  '/settings/analysis-groups/season': typeof SettingsAnalysisGroupsSeasonRoute
  '/settings/analysis-groups/sessions': typeof SettingsAnalysisGroupsSessionsRoute
  '/settings/club/coaches': typeof SettingsClubCoachesRoute
  '/settings/club/players': typeof SettingsClubPlayersRoute
  '/settings/club/transition': typeof SettingsClubTransitionRoute
  '/settings/metric/actions': typeof SettingsMetricActionsRoute
  '/settings/metric/advanced': typeof SettingsMetricAdvancedRoute
  '/settings/metric/calculator': typeof SettingsMetricCalculatorRoute
  '/settings/metric/zones': typeof SettingsMetricZonesRoute
  '/settings/preferences/languages': typeof SettingsPreferencesLanguagesRoute
  '/settings/preferences/units': typeof SettingsPreferencesUnitsRoute
  '/settings/report/daily': typeof SettingsReportDailyRoute
  '/settings/report/filter-preset': typeof SettingsReportFilterPresetRoute
  '/settings/report/report': typeof SettingsReportReportRoute
  '/settings/report/trend': typeof SettingsReportTrendRoute
  '/settings/resources/download': typeof SettingsResourcesDownloadRoute
  '/settings/analysis-groups/': typeof SettingsAnalysisGroupsIndexRoute
  '/settings/club/': typeof SettingsClubIndexRoute
  '/settings/metric/': typeof SettingsMetricIndexRoute
  '/settings/preferences/': typeof SettingsPreferencesIndexRoute
  '/settings/report/': typeof SettingsReportIndexRoute
  '/settings/resources/': typeof SettingsResourcesIndexRoute
  '/settings/club/equipments/delivery': typeof SettingsClubEquipmentsDeliveryRoute
  '/settings/club/equipments/': typeof SettingsClubEquipmentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/home'
    | '/notice'
    | '/activity/detail'
    | '/activity/list'
    | '/export/csv'
    | '/export/pdf'
    | '/report/ai-report'
    | '/report/daily'
    | '/report/report'
    | '/report/trend'
    | '/settings/overview'
    | '/signup/$authCode'
    | '/activity'
    | '/export'
    | '/report'
    | '/settings'
    | '/settings/analysis-groups/players'
    | '/settings/analysis-groups/season'
    | '/settings/analysis-groups/sessions'
    | '/settings/club/coaches'
    | '/settings/club/players'
    | '/settings/club/transition'
    | '/settings/metric/actions'
    | '/settings/metric/advanced'
    | '/settings/metric/calculator'
    | '/settings/metric/zones'
    | '/settings/preferences/languages'
    | '/settings/preferences/units'
    | '/settings/report/daily'
    | '/settings/report/filter-preset'
    | '/settings/report/report'
    | '/settings/report/trend'
    | '/settings/resources/download'
    | '/settings/analysis-groups'
    | '/settings/club'
    | '/settings/metric'
    | '/settings/preferences'
    | '/settings/report'
    | '/settings/resources'
    | '/settings/club/equipments/delivery'
    | '/settings/club/equipments'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/home'
    | '/notice'
    | '/activity/detail'
    | '/activity/list'
    | '/export/csv'
    | '/export/pdf'
    | '/report/ai-report'
    | '/report/daily'
    | '/report/report'
    | '/report/trend'
    | '/settings/overview'
    | '/signup/$authCode'
    | '/activity'
    | '/export'
    | '/report'
    | '/settings'
    | '/settings/analysis-groups/players'
    | '/settings/analysis-groups/season'
    | '/settings/analysis-groups/sessions'
    | '/settings/club/coaches'
    | '/settings/club/players'
    | '/settings/club/transition'
    | '/settings/metric/actions'
    | '/settings/metric/advanced'
    | '/settings/metric/calculator'
    | '/settings/metric/zones'
    | '/settings/preferences/languages'
    | '/settings/preferences/units'
    | '/settings/report/daily'
    | '/settings/report/filter-preset'
    | '/settings/report/report'
    | '/settings/report/trend'
    | '/settings/resources/download'
    | '/settings/analysis-groups'
    | '/settings/club'
    | '/settings/metric'
    | '/settings/preferences'
    | '/settings/report'
    | '/settings/resources'
    | '/settings/club/equipments/delivery'
    | '/settings/club/equipments'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/home'
    | '/notice'
    | '/activity/detail'
    | '/activity/list'
    | '/export/csv'
    | '/export/pdf'
    | '/report/ai-report'
    | '/report/daily'
    | '/report/report'
    | '/report/trend'
    | '/settings/overview'
    | '/signup/$authCode'
    | '/activity/'
    | '/export/'
    | '/report/'
    | '/settings/'
    | '/settings/analysis-groups/players'
    | '/settings/analysis-groups/season'
    | '/settings/analysis-groups/sessions'
    | '/settings/club/coaches'
    | '/settings/club/players'
    | '/settings/club/transition'
    | '/settings/metric/actions'
    | '/settings/metric/advanced'
    | '/settings/metric/calculator'
    | '/settings/metric/zones'
    | '/settings/preferences/languages'
    | '/settings/preferences/units'
    | '/settings/report/daily'
    | '/settings/report/filter-preset'
    | '/settings/report/report'
    | '/settings/report/trend'
    | '/settings/resources/download'
    | '/settings/analysis-groups/'
    | '/settings/club/'
    | '/settings/metric/'
    | '/settings/preferences/'
    | '/settings/report/'
    | '/settings/resources/'
    | '/settings/club/equipments/delivery'
    | '/settings/club/equipments/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  HomeRoute: typeof HomeRoute
  NoticeRoute: typeof NoticeRoute
  ActivityDetailRoute: typeof ActivityDetailRoute
  ActivityListRoute: typeof ActivityListRoute
  ExportCsvRoute: typeof ExportCsvRoute
  ExportPdfRoute: typeof ExportPdfRoute
  ReportAiReportRoute: typeof ReportAiReportRoute
  ReportDailyRoute: typeof ReportDailyRoute
  ReportReportRoute: typeof ReportReportRoute
  ReportTrendRoute: typeof ReportTrendRoute
  SettingsOverviewRoute: typeof SettingsOverviewRoute
  SignupAuthCodeRoute: typeof SignupAuthCodeRoute
  ActivityIndexRoute: typeof ActivityIndexRoute
  ExportIndexRoute: typeof ExportIndexRoute
  ReportIndexRoute: typeof ReportIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  SettingsAnalysisGroupsPlayersRoute: typeof SettingsAnalysisGroupsPlayersRoute
  SettingsAnalysisGroupsSeasonRoute: typeof SettingsAnalysisGroupsSeasonRoute
  SettingsAnalysisGroupsSessionsRoute: typeof SettingsAnalysisGroupsSessionsRoute
  SettingsClubCoachesRoute: typeof SettingsClubCoachesRoute
  SettingsClubPlayersRoute: typeof SettingsClubPlayersRoute
  SettingsClubTransitionRoute: typeof SettingsClubTransitionRoute
  SettingsMetricActionsRoute: typeof SettingsMetricActionsRoute
  SettingsMetricAdvancedRoute: typeof SettingsMetricAdvancedRoute
  SettingsMetricCalculatorRoute: typeof SettingsMetricCalculatorRoute
  SettingsMetricZonesRoute: typeof SettingsMetricZonesRoute
  SettingsPreferencesLanguagesRoute: typeof SettingsPreferencesLanguagesRoute
  SettingsPreferencesUnitsRoute: typeof SettingsPreferencesUnitsRoute
  SettingsReportDailyRoute: typeof SettingsReportDailyRoute
  SettingsReportFilterPresetRoute: typeof SettingsReportFilterPresetRoute
  SettingsReportReportRoute: typeof SettingsReportReportRoute
  SettingsReportTrendRoute: typeof SettingsReportTrendRoute
  SettingsResourcesDownloadRoute: typeof SettingsResourcesDownloadRoute
  SettingsAnalysisGroupsIndexRoute: typeof SettingsAnalysisGroupsIndexRoute
  SettingsClubIndexRoute: typeof SettingsClubIndexRoute
  SettingsMetricIndexRoute: typeof SettingsMetricIndexRoute
  SettingsPreferencesIndexRoute: typeof SettingsPreferencesIndexRoute
  SettingsReportIndexRoute: typeof SettingsReportIndexRoute
  SettingsResourcesIndexRoute: typeof SettingsResourcesIndexRoute
  SettingsClubEquipmentsDeliveryRoute: typeof SettingsClubEquipmentsDeliveryRoute
  SettingsClubEquipmentsIndexRoute: typeof SettingsClubEquipmentsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/notice': {
      id: '/notice'
      path: '/notice'
      fullPath: '/notice'
      preLoaderRoute: typeof NoticeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/report/': {
      id: '/report/'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof ReportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export/': {
      id: '/export/'
      path: '/export'
      fullPath: '/export'
      preLoaderRoute: typeof ExportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity/': {
      id: '/activity/'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/$authCode': {
      id: '/signup/$authCode'
      path: '/signup/$authCode'
      fullPath: '/signup/$authCode'
      preLoaderRoute: typeof SignupAuthCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/overview': {
      id: '/settings/overview'
      path: '/settings/overview'
      fullPath: '/settings/overview'
      preLoaderRoute: typeof SettingsOverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/report/trend': {
      id: '/report/trend'
      path: '/report/trend'
      fullPath: '/report/trend'
      preLoaderRoute: typeof ReportTrendRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/report/report': {
      id: '/report/report'
      path: '/report/report'
      fullPath: '/report/report'
      preLoaderRoute: typeof ReportReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/report/daily': {
      id: '/report/daily'
      path: '/report/daily'
      fullPath: '/report/daily'
      preLoaderRoute: typeof ReportDailyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/report/ai-report': {
      id: '/report/ai-report'
      path: '/report/ai-report'
      fullPath: '/report/ai-report'
      preLoaderRoute: typeof ReportAiReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export/pdf': {
      id: '/export/pdf'
      path: '/export/pdf'
      fullPath: '/export/pdf'
      preLoaderRoute: typeof ExportPdfRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export/csv': {
      id: '/export/csv'
      path: '/export/csv'
      fullPath: '/export/csv'
      preLoaderRoute: typeof ExportCsvRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity/list': {
      id: '/activity/list'
      path: '/activity/list'
      fullPath: '/activity/list'
      preLoaderRoute: typeof ActivityListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity/detail': {
      id: '/activity/detail'
      path: '/activity/detail'
      fullPath: '/activity/detail'
      preLoaderRoute: typeof ActivityDetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/resources/': {
      id: '/settings/resources/'
      path: '/settings/resources'
      fullPath: '/settings/resources'
      preLoaderRoute: typeof SettingsResourcesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/report/': {
      id: '/settings/report/'
      path: '/settings/report'
      fullPath: '/settings/report'
      preLoaderRoute: typeof SettingsReportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/preferences/': {
      id: '/settings/preferences/'
      path: '/settings/preferences'
      fullPath: '/settings/preferences'
      preLoaderRoute: typeof SettingsPreferencesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/metric/': {
      id: '/settings/metric/'
      path: '/settings/metric'
      fullPath: '/settings/metric'
      preLoaderRoute: typeof SettingsMetricIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/club/': {
      id: '/settings/club/'
      path: '/settings/club'
      fullPath: '/settings/club'
      preLoaderRoute: typeof SettingsClubIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/analysis-groups/': {
      id: '/settings/analysis-groups/'
      path: '/settings/analysis-groups'
      fullPath: '/settings/analysis-groups'
      preLoaderRoute: typeof SettingsAnalysisGroupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/resources/download': {
      id: '/settings/resources/download'
      path: '/settings/resources/download'
      fullPath: '/settings/resources/download'
      preLoaderRoute: typeof SettingsResourcesDownloadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/report/trend': {
      id: '/settings/report/trend'
      path: '/settings/report/trend'
      fullPath: '/settings/report/trend'
      preLoaderRoute: typeof SettingsReportTrendRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/report/report': {
      id: '/settings/report/report'
      path: '/settings/report/report'
      fullPath: '/settings/report/report'
      preLoaderRoute: typeof SettingsReportReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/report/filter-preset': {
      id: '/settings/report/filter-preset'
      path: '/settings/report/filter-preset'
      fullPath: '/settings/report/filter-preset'
      preLoaderRoute: typeof SettingsReportFilterPresetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/report/daily': {
      id: '/settings/report/daily'
      path: '/settings/report/daily'
      fullPath: '/settings/report/daily'
      preLoaderRoute: typeof SettingsReportDailyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/preferences/units': {
      id: '/settings/preferences/units'
      path: '/settings/preferences/units'
      fullPath: '/settings/preferences/units'
      preLoaderRoute: typeof SettingsPreferencesUnitsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/preferences/languages': {
      id: '/settings/preferences/languages'
      path: '/settings/preferences/languages'
      fullPath: '/settings/preferences/languages'
      preLoaderRoute: typeof SettingsPreferencesLanguagesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/metric/zones': {
      id: '/settings/metric/zones'
      path: '/settings/metric/zones'
      fullPath: '/settings/metric/zones'
      preLoaderRoute: typeof SettingsMetricZonesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/metric/calculator': {
      id: '/settings/metric/calculator'
      path: '/settings/metric/calculator'
      fullPath: '/settings/metric/calculator'
      preLoaderRoute: typeof SettingsMetricCalculatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/metric/advanced': {
      id: '/settings/metric/advanced'
      path: '/settings/metric/advanced'
      fullPath: '/settings/metric/advanced'
      preLoaderRoute: typeof SettingsMetricAdvancedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/metric/actions': {
      id: '/settings/metric/actions'
      path: '/settings/metric/actions'
      fullPath: '/settings/metric/actions'
      preLoaderRoute: typeof SettingsMetricActionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/club/transition': {
      id: '/settings/club/transition'
      path: '/settings/club/transition'
      fullPath: '/settings/club/transition'
      preLoaderRoute: typeof SettingsClubTransitionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/club/players': {
      id: '/settings/club/players'
      path: '/settings/club/players'
      fullPath: '/settings/club/players'
      preLoaderRoute: typeof SettingsClubPlayersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/club/coaches': {
      id: '/settings/club/coaches'
      path: '/settings/club/coaches'
      fullPath: '/settings/club/coaches'
      preLoaderRoute: typeof SettingsClubCoachesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/analysis-groups/sessions': {
      id: '/settings/analysis-groups/sessions'
      path: '/settings/analysis-groups/sessions'
      fullPath: '/settings/analysis-groups/sessions'
      preLoaderRoute: typeof SettingsAnalysisGroupsSessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/analysis-groups/season': {
      id: '/settings/analysis-groups/season'
      path: '/settings/analysis-groups/season'
      fullPath: '/settings/analysis-groups/season'
      preLoaderRoute: typeof SettingsAnalysisGroupsSeasonRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/analysis-groups/players': {
      id: '/settings/analysis-groups/players'
      path: '/settings/analysis-groups/players'
      fullPath: '/settings/analysis-groups/players'
      preLoaderRoute: typeof SettingsAnalysisGroupsPlayersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/club/equipments/': {
      id: '/settings/club/equipments/'
      path: '/settings/club/equipments'
      fullPath: '/settings/club/equipments'
      preLoaderRoute: typeof SettingsClubEquipmentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/club/equipments/delivery': {
      id: '/settings/club/equipments/delivery'
      path: '/settings/club/equipments/delivery'
      fullPath: '/settings/club/equipments/delivery'
      preLoaderRoute: typeof SettingsClubEquipmentsDeliveryRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  HomeRoute: HomeRoute,
  NoticeRoute: NoticeRoute,
  ActivityDetailRoute: ActivityDetailRoute,
  ActivityListRoute: ActivityListRoute,
  ExportCsvRoute: ExportCsvRoute,
  ExportPdfRoute: ExportPdfRoute,
  ReportAiReportRoute: ReportAiReportRoute,
  ReportDailyRoute: ReportDailyRoute,
  ReportReportRoute: ReportReportRoute,
  ReportTrendRoute: ReportTrendRoute,
  SettingsOverviewRoute: SettingsOverviewRoute,
  SignupAuthCodeRoute: SignupAuthCodeRoute,
  ActivityIndexRoute: ActivityIndexRoute,
  ExportIndexRoute: ExportIndexRoute,
  ReportIndexRoute: ReportIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SettingsAnalysisGroupsPlayersRoute: SettingsAnalysisGroupsPlayersRoute,
  SettingsAnalysisGroupsSeasonRoute: SettingsAnalysisGroupsSeasonRoute,
  SettingsAnalysisGroupsSessionsRoute: SettingsAnalysisGroupsSessionsRoute,
  SettingsClubCoachesRoute: SettingsClubCoachesRoute,
  SettingsClubPlayersRoute: SettingsClubPlayersRoute,
  SettingsClubTransitionRoute: SettingsClubTransitionRoute,
  SettingsMetricActionsRoute: SettingsMetricActionsRoute,
  SettingsMetricAdvancedRoute: SettingsMetricAdvancedRoute,
  SettingsMetricCalculatorRoute: SettingsMetricCalculatorRoute,
  SettingsMetricZonesRoute: SettingsMetricZonesRoute,
  SettingsPreferencesLanguagesRoute: SettingsPreferencesLanguagesRoute,
  SettingsPreferencesUnitsRoute: SettingsPreferencesUnitsRoute,
  SettingsReportDailyRoute: SettingsReportDailyRoute,
  SettingsReportFilterPresetRoute: SettingsReportFilterPresetRoute,
  SettingsReportReportRoute: SettingsReportReportRoute,
  SettingsReportTrendRoute: SettingsReportTrendRoute,
  SettingsResourcesDownloadRoute: SettingsResourcesDownloadRoute,
  SettingsAnalysisGroupsIndexRoute: SettingsAnalysisGroupsIndexRoute,
  SettingsClubIndexRoute: SettingsClubIndexRoute,
  SettingsMetricIndexRoute: SettingsMetricIndexRoute,
  SettingsPreferencesIndexRoute: SettingsPreferencesIndexRoute,
  SettingsReportIndexRoute: SettingsReportIndexRoute,
  SettingsResourcesIndexRoute: SettingsResourcesIndexRoute,
  SettingsClubEquipmentsDeliveryRoute: SettingsClubEquipmentsDeliveryRoute,
  SettingsClubEquipmentsIndexRoute: SettingsClubEquipmentsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
